import React from 'react';
import { MarkerLabel } from 'types/markerTypesV2/m-v2-general.js';

export const PillLabelV2 = ({ label, children }: { label?: MarkerLabel; children: React.ReactNode }): JSX.Element => {
  /**
   * We need to set the anchor point iconAnchor
   * For text shadow apply text-shadow-black
   *  */
  return (
    <div data-module="pill-label-v2" className="Pill pill--padding pill--border border-pill-label">
      <div
        data-playwright-id={`marker-${(label?.text ?? '').toLowerCase()?.replaceAll(' ', '-')}`}
        className="bg-transparent u-text-sm u-textBold u-textNoWrap u-pT-xxs u-pB-xxs u-pL-ssm u-pR-ssm u-flex u-flexAlignItemsCenter u-textWhite"
      >
        <span className="u-flex-1">{label?.text}</span>
        <div className="u-flex-1">{children}</div>
      </div>
    </div>
  );
};
